<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules" size="small">
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_custCategoryNameEn') || '英文品类名称'"
            prop="custCategoryNameEn"
          >
            <el-input
              v-model="formData.custCategoryNameEn"
              :placeholder="
                $l('form_placeholder_custCategoryNameEn') ||
                  '请输入英文品类名称'
              "
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_custCategoryName') || '中文品类名称'"
            prop="custCategoryName"
          >
            <el-input
              v-model="formData.custCategoryName"
              :placeholder="
                $l('form_placeholder_custCategoryName') || '请输入中文品类名称'
              "
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    custCode: { type: String, default: '' },
    custCategoryCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {},
      rules: {
        custCategoryNameEn: [
          {
            required: true,
            message:
              this.$l('form_placeholder_custCategoryNameEn') ||
              '请输入英文品类名称',
            trigger: 'blur',
          },
        ],
        custCategoryName: [
          {
            required: true,
            message:
              this.$l('form_placeholder_custCategoryName') ||
              '请输入中文品类名称',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.custCategoryCode) return
      const res = await this.$api
        .masterCustomerCategoryDetailApi({
          custCategoryCode: this.custCategoryCode,
        })
        .catch(() => null)
      if (!res) return
      this.formData = res.body
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .masterCustomerCategorySaveApi({
          ...this.formData,
          custCode: this.custCode,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })

      this.$emit('reload')
      this.close()
    },
    cancel() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存',
        }
      )
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') this.close()
        })
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>
